// Does the desktop two-column grid actually FIT?
//
// `useHomeBreakpoints().isDesktop` only says "the viewport is >= 1200px", which
// is enough to decide the chrome (sidebar vs bottom tabs) but NOT the body: the
// sidebar eats 288px, so the content area is `width - 288`. The two-column row
// (main + gap + 408px right column + page gutters) needs far more than that, and
// because RN children default to `flexShrink: 0` the row used to overflow and
// clip the middle card on small desktops instead of wrapping.
//
// So the body asks this helper instead. When it returns false the screen falls
// back to the single-column shell (sidebar kept, guide panel moves into the
// header bottom sheet) — the same layout the tablet tier already uses.
import { LAYOUT } from './tokens'
import { HomeLayout } from './useHomeBreakpoints'

/** Horizontal page padding on each side of the desktop grid. */
export const CONTENT_GUTTER = 24

/**
 * @param minMainWidth the narrowest the main/left column may be squeezed to.
 * The column itself is laid out with `flexShrink: 1` so it takes up the slack
 * between this floor and its natural width.
 */
export const getFitsTwoColumn = (layout: HomeLayout, minMainWidth: number): boolean => {
  if (!layout.isDesktop) return false

  const contentWidth = layout.width - LAYOUT.sidebarWidth

  return contentWidth >= minMainWidth + LAYOUT.gridGap + LAYOUT.gridRightWidth + CONTENT_GUTTER * 2
}

export default getFitsTwoColumn
